import axios from 'axios'

//过滤请求
axios.interceptors.request.use(config => {
    let defaultConfig = {
        timeout: 10 * 1000,         // 超时时间, 单位毫秒
        // data: qs.stringify({}),  // post参数 qs.stringify(data)数据处理, 主要是配合下面headers里的Content-Type, 转成表单提交, 让后端可以直接用 $_POST 拿到数据
        withCredentials: true,
    };
    return {...config,...defaultConfig};
}, error => {
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code === 0) {   //服务端定义的响应code码为0时请求成功
            return Promise.resolve(response.data) //使用Promise.resolve 正常响应
        } else if (response.data.code === 1111) { //服务端定义的响应code码为1111时为未登录
            return Promise.reject(response.data); //使用Promise.reject 抛出错误和异常
        } else {
            return Promise.reject(response.data);
        }
    },
    error => {
        if (error && error.response) {
            let res = {};
            res.code = error.response.status;
            res.msg = '报错了';
            // res.msg = throwErr(error.response.status, error.response); //throwErr 捕捉服务端的http状态码 定义在utils工具类的方法
            return Promise.reject(res);
        }
        return Promise.reject(error);
    }
);

export const request = (method, url, data)=> {  //暴露 request 给我们好API 管理
    console.log('ggggg....',data)
    method = method.toLocaleLowerCase();   //封装method API的各种请求方式 以 post get delete为例
    if (method === 'post') {
        return axios.post(url, data);    //axios的post 默认转化为json格式
    } else if (method === 'get') {
        console.log('ggg2')
        return axios.get(url, {
            params: data
        });
    } else if (method === 'delete') {
        return axios.delete(url, {
            params: data
        });
    }
}